<template>
  <div>

    <!--<modal-filter :filterCategories="filterCategories" :filterFor="'products'"></modal-filter>-->

    <navbar></navbar>

    <div v-if="shop">
      <div class="bg-header-round-small">
        <div class="container">
          <h1>{{ shop.name }}</h1>
          <button @click.prevent="goTo('shop', {'id': shop.uid})" class="btn orange mt-4" >Zurück zur Händler-Übersicht</button>
        </div>
      </div>
    </div>

    <div v-if="loadingShop" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>

    <div v-if="shop" >
      <productList :loading="loadingMore" :shop="shop" v-on:more="loadMore" :title="'Produkt Übersicht'" :products="productList" :type="'main'"></productList>
    </div>

    <benefits></benefits>

    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import ProductList from '../components/ProductList.vue'
  import Benefits from '../components/Benefits.vue'
  import CgFooter from '../components/CgFooter.vue'
  import Filter from '../components/modals/Filter.vue'
  import CgLoader from '../components/menus/cgLoader'

  import { mapGetters, mapActions } from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'shop-overview',
    components: {
      CgLoader,
      'navbar': Navbar,
      'productList': ProductList,
      'benefits': Benefits,
      'cgfooter': CgFooter,
      'modal-filter': Filter
    },
    mixins: [helpers, formatting],
    data () {
      return {
        filterCategories: [],
        loadingShop: true,
        loadingMore: false
      }
    },
    created () {
      var self = this
      this.getShopDetails({
        uid: this.$route.params.shop,
        cb () {
          self.loadingShop = false
        },
        errorCb () {
          self.loadingShop = false
        }
      })
      this.getShopProductList({shop: this.$route.params.shop})
    },
    methods: {
      ...mapActions([
        'getShopDetails',
        'getShopProductList',
        'getMore'
      ]),
      loadMore () {
        var self = this
        this.loadingMore = true
        this.getMore({
          url: this.productList.links.next,
          commit: 'SHOP_PRODUCT_LIST_PAGE',
          cb () {
            self.loadingMore = false
          },
          errorCb () {
            self.loadingMore = false
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        shop: 'shop_get_details',
        productList: 'shop_get_product_list'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ShopProducts.vue